export const GetDateTime = "GetDateTime";
export const GetDateTimeSuccess = "GetDateTimeSuccess";
export const GetDateTimeError = "GetDateTimeError";
export const ResetDateTime = "ResetDateTime";
export const GetLastDayPeriod = "GetLastDayPeriod";
export const GetLastWeekPeriod = "GetLastWeekPeriod";
export const GetLastMonthPeriod = "GetLastMonthPeriod";
export const GetSelectedPeriod = "GetSelectedPeriod";
export const OpenDateTimePicker = "OpenDateTimePicker";
